import { FiatCurrency } from '#src/__generated__/globalTypes.ts';

import { useCurrentUserCurrencies } from './useCurrentUserCurrencies.tsx';

export const useMangopayCreditCardsEnabled = () => {
  const { fiatCurrency } = useCurrentUserCurrencies();
  return fiatCurrency !== FiatCurrency.USD;
};
